var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticStyle: {
        "background-color": "#F0F0EF",
        height: "535px",
        overflow: "auto"
      }
    },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass: "d-flex text-left flex-column",
              staticStyle: { "max-width": "240px" },
              attrs: { cols: "6", sm: "4" }
            },
            [
              _c("span", { staticClass: "search-title" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$tc("UnscheduledTasks")) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _vm._l(_vm.calendarUsers, function(user, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    staticClass:
                      "d-flex align-center justify-start mt-3 mr-1 flex-column"
                  },
                  [
                    _vm.tasksWithOwner.find(function(item) {
                      return (
                        item.user_assignee_id === user && !item.scheduled_date
                      )
                    })
                      ? _c(
                          "div",
                          {
                            staticClass: "d-flex align-center justify-start",
                            staticStyle: { width: "100%" }
                          },
                          [
                            _c(
                              "v-avatar",
                              { attrs: { height: "25", width: "25" } },
                              [
                                _c("img", {
                                  attrs: { src: _vm.getImageUrl(user) }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("h5", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.getUserName(user)) +
                                  "\n          "
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.tasksWithOwner, function(tasks, i) {
                      return _c(
                        "div",
                        { key: i, staticClass: "ml-7" },
                        [
                          tasks.user_assignee_id === user &&
                          !tasks.scheduled_date
                            ? _c(
                                "v-card",
                                {
                                  staticClass: "mb-2 mt-1",
                                  staticStyle: { border: "1px solid #C9C9C9" },
                                  attrs: {
                                    elevation: "0",
                                    "max-width": "170",
                                    width: "130",
                                    "min-height": "60"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.addtoCalendar(tasks, user)
                                    }
                                  }
                                },
                                [
                                  tasks.activityLabel
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            padding: "5px",
                                            "margin-bottom": "-5px"
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "d-flex align-start task-text",
                                              attrs: {
                                                title: tasks.activityLabel
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(tasks.activityLabel) +
                                                  " - " +
                                                  _vm._s(_vm.$tc("Activity"))
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-truncate task-text",
                                              attrs: { title: tasks.title }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(_vm._s(tasks.title))
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            padding: "5px",
                                            "margin-bottom": "-5px"
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "d-flex align-start task-text",
                                              attrs: { title: tasks.activityId }
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.getObjectTypeLabel(
                                                      tasks.activityObject
                                                    )
                                                  ) +
                                                  " - ID\n                " +
                                                  _vm._s(tasks.activityId) +
                                                  " - " +
                                                  _vm._s(_vm.$tc("Activity"))
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-truncate task-text",
                                              attrs: { title: tasks.title }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(_vm._s(tasks.title))
                                              ])
                                            ]
                                          )
                                        ]
                                      ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "d-flex justify-end mr-1 estimated-time",
                                      attrs: { title: tasks.title }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(tasks.execution_time) + " min"
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              }),
              _vm._v(" "),
              _c("div", { staticClass: "left-side" })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6", md: "8" } },
            [
              _c(
                "v-row",
                { staticClass: "fill-height" },
                [
                  _c(
                    "v-col",
                    [
                      _c(
                        "v-sheet",
                        {
                          staticClass: "d-flex justify-start align-baseline",
                          attrs: { color: "transparent" }
                        },
                        [
                          _c(
                            "v-menu",
                            {
                              attrs: {
                                bottom: "",
                                "close-on-content-click": false,
                                "nudge-width": "160"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _vm.userId
                                        ? _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "mb-1",
                                                  attrs: { small: "", text: "" }
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.getUserName(_vm.userId)
                                                  )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ])
                            },
                            [
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "text-input-height",
                                attrs: {
                                  placeholder: _vm.$tc("SearchUser"),
                                  clearable: "",
                                  color: "accent"
                                },
                                model: {
                                  value: _vm.searchUser,
                                  callback: function($$v) {
                                    _vm.searchUser = $$v
                                  },
                                  expression: "searchUser"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "v-list",
                                {
                                  staticStyle: { overflow: "auto" },
                                  attrs: {
                                    "one-line": "",
                                    dense: "",
                                    height: "167px"
                                  }
                                },
                                [
                                  _vm._l(_vm.filteredUsers, function(user, i) {
                                    return [
                                      _c(
                                        "v-list-item",
                                        {
                                          key: i,
                                          staticStyle: {
                                            "padding-left": "0px"
                                          },
                                          attrs: { dense: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.selectUser(user)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-item-avatar",
                                            {
                                              attrs: {
                                                height: "25px",
                                                width: "25px",
                                                "min-width": "25px"
                                              }
                                            },
                                            [
                                              _c("v-img", {
                                                attrs: {
                                                  src: _vm.getImageUrl(user),
                                                  sizes: "small"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c("v-list-item-subtitle", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.getUserName(user)
                                                  )
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.userId ? _c("span", [_vm._v("•")]) : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-menu",
                            {
                              attrs: {
                                "close-on-content-click": false,
                                "nudge-right": 40,
                                transition: "scale-transition",
                                "offset-y": "",
                                "min-width": "auto"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        "span",
                                        _vm._g(
                                          _vm._b(
                                            { staticClass: "text-size ml-2" },
                                            "span",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [_vm._v(_vm._s(_vm.title))]
                                      )
                                    ]
                                  }
                                }
                              ]),
                              model: {
                                value: _vm.menu2,
                                callback: function($$v) {
                                  _vm.menu2 = $$v
                                },
                                expression: "menu2"
                              }
                            },
                            [
                              _vm._v(" "),
                              _c("v-date-picker", {
                                on: {
                                  input: function($event) {
                                    _vm.menu2 = false
                                  }
                                },
                                model: {
                                  value: _vm.date,
                                  callback: function($$v) {
                                    _vm.date = $$v
                                  },
                                  expression: "date"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("calendar", {
                        ref: "calendar",
                        attrs: {
                          receivedEvents: _vm.events,
                          taskToAssign: _vm.taskToAssign,
                          choosenDate: _vm.date,
                          disabledView: _vm.disabledView,
                          startDate: _vm.receivedData.start_date,
                          endDate: _vm.receivedData.end_date
                        },
                        on: {
                          taskAdded: _vm.taskToAssignState,
                          updateTime: _vm.updateTime,
                          removeTask: _vm.removeTask
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eef72274", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eef72274","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/WorkOrderForm/WorkOrderSchedule.vue
// module id = null
// module chunks = 